import { useEffect, useState } from "react";
import { webHostEnviroment } from "../enums";

export const useGetWebHostEnvironment = (hostName?: string): string => {
  const [env, setEnv] = useState("non-browser-env");

  useEffect(() => {
    const hostNameToCheck = hostName || window.location.hostname;

    setEnv(
      hostNameToCheck.includes("localhost")
        ? webHostEnviroment.development
        : hostNameToCheck.includes("test")
        ? webHostEnviroment.test
        : hostNameToCheck.includes("staging")
        ? webHostEnviroment.staging
        : webHostEnviroment.production
    );
  }, [hostName]);

  return env;
};
